import React, { Fragment } from 'react';
export var ManagementCompaniesFilterStatus = function ManagementCompaniesFilterStatus(_ref) {
  var Object = _ref.productType,
    qty = _ref.qty,
    totalItems = _ref.totalItems,
    category = _ref.category;
  return React.createElement("div", null, qty < totalItems ? React.createElement("div", null, "Est\xE1s viendo ", qty, " de ", totalItems, " gestoras", category ? React.createElement(Fragment, null, " con la categor\xEDa ", category.name) : '') : React.createElement("div", null, "Viendo ", qty, " gestoras"));
};